import { render, staticRenderFns } from "./clickJumpModal.vue?vue&type=template&id=32c1551b&scoped=true"
import script from "./clickJumpModal.vue?vue&type=script&lang=js"
export * from "./clickJumpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c1551b",
  null
  
)

export default component.exports